"use strict";

jQuery(document).ready(function (jQuery) {
  jQuery(document).foundation();
  var body = jQuery("body");
  var nav = jQuery("nav#site-navigation");
  var header = jQuery(".site-header");
  jQuery('button#openMenu').click(function () {
    nav.addClass("open");
    body.addClass("open");
    header.addClass("nav-up");
  });
  var btn = $('#back-to-top');
  $(window).scroll(function () {
    if ($(window).scrollTop() > 300) {
      btn.addClass('show');
    } else {
      btn.removeClass('show');
    }
  });
  btn.on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, '300');
  });
  function isScrolledIntoView(elem) {
    var docViewTop = jQuery(window).scrollTop();
    var docViewBottom = docViewTop + (jQuery(window).height() + 200); // 200px offset for earlier response

    var elemTop = jQuery(elem).offset().top;
    var elemBottom = elemTop + jQuery(elem).height();
    return elemBottom <= docViewBottom && elemTop >= docViewTop;
  }
  jQuery('button#close-menu').click(function () {
    nav.removeClass("open");
    body.removeClass("open");
    header.removeClass("nav-up");
  });

  // jQuery(".open-day-container").click(function () {
  //     console.log('Click');
  //     jQuery(this).closest('.open-day-card').find(".btn-sub-container").slideToggle();
  //     return false;
  // });

  function slideCalendarMenu(el) {
    jQuery(el).closest('.open-day-card').find(".btn-sub-container").slideToggle();
    return false;
  }
  jQuery('button#openTab').click(function () {
    $(this).toggleClass('open');
    $('.open-days').slideToggle('medium', function () {
      if ($(this).is(':visible')) $(this).css('display', 'flex');
    });
  });
  var ul = jQuery("nav#site-navigation ul li ul");
  var li = jQuery("nav#site-navigation ul li ul li");
  if (ul.hasClass("children")) {
    ul.parent(li).addClass("hasChildren");
  }
  if (li.hasClass("hasChildren")) {
    jQuery("li.hasChildren a").append("<a href='javascript:void(0)' class='expandChild' title='Child item'></a>");
  }
  jQuery(document).mouseup(function (e) {
    if (!nav.is(e.target) // if the target of the click isn't the container...
    && nav.has(e.target).length === 0)
      // ... nor a descendant of the container
      {
        nav.removeClass('open');
        body.removeClass("open");
        header.removeClass("nav-up");
      }
  });
  jQuery(document).ready(function () {
    jQuery('.open-search-from').click(function () {
      jQuery('section').addClass("open-search");
      jQuery('body').addClass("search-main");
    });
    jQuery('#deleteSearch').click(function () {
      jQuery('section').removeClass("open-search");
      jQuery('body').removeClass("search-main");
    });
  });
  jQuery(window).on('scroll touchmove', function () {
    jQuery('.fade-in').each(function () {
      if (isScrolledIntoView(jQuery(this))) {
        jQuery(this).addClass('animation-started');
      }
    });
  });
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = jQuery('header').outerHeight();
  jQuery(window).scroll(function (event) {
    didScroll = true;
  });
  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);
  function hasScrolled() {
    var st = jQuery(window).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      jQuery('header').removeClass('nav-down').addClass('nav-up');
    } else {
      // Scroll Up
      if (st + jQuery(window).height() < jQuery(document).height()) {
        jQuery('header').removeClass('nav-up').addClass('nav-down');
      }
    }
    lastScrollTop = st;
  }
});
jQuery.event.special.touchstart = {
  setup: function setup(_, ns, handle) {
    this.addEventListener('touchstart', handle, {
      passive: !ns.includes('noPreventDefault')
    });
  }
};
jQuery.event.special.touchmove = {
  setup: function setup(_, ns, handle) {
    this.addEventListener('touchmove', handle, {
      passive: !ns.includes('noPreventDefault')
    });
  }
};
jQuery(function ($) {
  $(document).on('facetwp-refresh', function () {
    if (FWP.loaded) {
      FWP.setHash();
      window.location.reload();
    }
    $('.open-day-card').each(function () {
      var pNode = this;
      $(this).find('.open-day-container.btn').on('click', function () {
        jQuery(pNode).find('.btn-sub-container').slideToggle();
      });
    });
  });
});